module.exports = __webpack_public_path__ + "media/assets/images/category/Graduation@2x-12c70620d6a349a89e5ba05ef2b99acc.png";